import { api } from '@/shared/services/api';
import {
  IInvoiceRepository,
  RetroactiveInvoiceRequestOutcome,
} from '../../domain/repositories/IInvoiceRepository';
import { Invoice, InvoiceDocumentType } from '../../domain/entities/Invoice';

interface InvoiceApiItem {
  id: string;
  date: string;
  concept: string;
  amount: number;
  currency: string;
  /** Opcional (D15): un backend anterior a este change no lo envía. Ver `Invoice.documentType`. */
  documentType?: InvoiceDocumentType;
}

/**
 * InvoiceHttpRepository (Adapter)
 *
 * Consume el listado y la descarga de facturas descargables de la organización
 * autenticada (`/v2/organizations/invoices`, molde `cancelScheduledPlanDowngrade`/`updateAutoRenew`
 * en `OrganizationHttpRepository.ts` — mismo prefijo `/v2` explícito). `downloadPdf` pasa
 * `{ responseType: 'blob' }` (D9): el JWT viaja igual gracias al interceptor de request de `api.ts`.
 */
export class InvoiceHttpRepository implements IInvoiceRepository {
  async list(): Promise<Invoice[]> {
    const response = await api.get<{ data: InvoiceApiItem[] }>('/v2/organizations/invoices');
    return response.data.data.map((item) => Invoice.fromPrimitives(item));
  }

  async downloadPdf(id: string): Promise<Blob> {
    const response = await api.get<Blob>(`/v2/organizations/invoices/${id}/pdf`, {
      responseType: 'blob',
    });
    return response.data;
  }

  async requestRetroactiveInvoice(
    paymentReferenceId: string
  ): Promise<{ outcome: RetroactiveInvoiceRequestOutcome }> {
    const response = await api.post<{ data: { outcome: RetroactiveInvoiceRequestOutcome } }>(
      `/v2/organizations/invoices/${paymentReferenceId}/request-retroactive`
    );
    return response.data.data;
  }
}
